import styled from 'styled-components';
import { theme } from 'styles';
import { CenterFlex, Flex } from 'UI';

export const PrerequisitiesWrapper = styled.ul`
  padding-left: 0;
  list-style: none;

  li {
    margin-bottom: 5px;
    display: flex;
    align-items: center;
  }

  li::before {
    content: '•';
    font-size: 15px;
    margin: 0 8px 0 8px;
  }
`;

export const DmsInfoWrapper = styled(Flex)`
  border-radius: 7px;
`;

export const DmsPic = styled(CenterFlex)`
  background-color: ${theme.color.grey10};
  flex: 0 0 auto;
  width: 120px;
  height: 100px;
  border-radius: 5px;
`;
